<template>
  <div>
    <div v-if="isPC">
      <search-head @handleSearch="handleSearch"></search-head>
      <div class="search-center w">
        <h6>
          {{ $t('Home.helpCenter.SearchCenter.ShowingAllResultsFor') }}:
          <span>{{listForm.searchName}}</span>
        </h6>
        <h1>{{ $t('Home.helpCenter.SearchCenter.FAQ') }}</h1>
        <div class="faq-list" v-for="item in FAQList" :key="item.id">
          <h2 v-html="item.mobileTitle"></h2>
          <div v-html="item.content"></div>
        </div>
        <h1>{{ $t('Home.helpCenter.SearchCenter.Tutorial') }}</h1>
        <div class="faq-list" v-for="item in tutorialList" :key="item.id" @click="toTutorialDetail(item)">
          <h2 v-html="item.mobileTitle"></h2>
          <div style="color:#8b93a3;width:100%" v-html="item.text" class="ellipsis2"></div>
        </div>
      </div>
    </div>
    <div v-else >
      <div class="bg-white search-bar">
        <MobileSerachHead @change="handleMobileSearch" style="width:100%"/>
      <h6>{{ $t('Home.helpCenter.SearchCenter.ShowingAllResultsFor') }}:
        <mark>{{listForm.searchName}}</mark>
      </h6>
      </div>
      <div class="mobile-search-center">
      <h1>{{ $t('Home.helpCenter.SearchCenter.FAQ') }}</h1>
      <div class="mobile-faq-list" v-for="item in FAQList" :key="item.id" >
        <h2 v-html="item.mobileTitle"></h2>
        <div v-html="item.content"></div>
      </div>
      <h1 style="padding-top:0.6rem">{{ $t('Home.helpCenter.SearchCenter.Tutorial') }}</h1>
      <div class="mobile-faq-list pointer" v-for="item in tutorialList" :key="item.id" @click="toTutorialDetail(item)">
        <h2 v-html="item.mobileTitle">{{item.mobileTitle}}</h2>
        <div style="width:100%;color: #4f4f4f " class="ellipsis2" v-html="item.text"></div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import SearchHead from './components/SearchHead'
import MobileSerachHead from './components/MobileSerachHead'
export default {
  components: { SearchHead, MobileSerachHead },
  data() {
    return {
      listForm: {
        pageNumber: 1,
        pageSize: 100000
      },
      value: '',
      FAQList: [],
      tutorialList: []
    }
  },
  created() {
    this.handleMobileSearch()
    if (this.isPC) {
      this.handleSearch()
    }
  },
  methods: {
    handleMobileSearch(value) {
      if (value) {
        this.listForm.searchName = value
      } else {
        this.listForm.searchName = this.$route.query.keyword
      }
      this.getEssayList()
    },
    handleSearch(value) {
      if (value) {
        this.listForm.searchName = value
      } else {
        this.listForm.searchName = this.$route.query.keyword
      }
      this.getEssayList()
    },

    getEssayList() {
      this.tutorialList = []
      this.FAQList = []
      API.getEssayList(this.listForm).then(res => {
        if (res.data.list && res.data.list.length > 0) {
          let data = _.cloneDeep(res.data.list)
          let Tutorial = _.cloneDeep(res.data.list)
          this.FAQList = data.filter(item => { return item.labelName === 'FAQ' })
          this.tutorialList = Tutorial.filter(item => { return item.labelName === 'Tutorial' })
          this.FAQList.forEach(item => {
            item.mobileTitle = `<div>${item.title}</div>`
            item.mobileTitle = item.mobileTitle.replace(this.listForm.searchName, '<mark >' + this.listForm.searchName + '</mark>')
            item.content = item.content.replace(this.listForm.searchName, '<mark >' + this.listForm.searchName + '</mark>')
          })
          this.tutorialList.forEach(item => {
            item.mobileTitle = `<div>${item.title}</div>`
            item.mobileTitle = item.mobileTitle.replace(this.listForm.searchName, '<mark >' + this.listForm.searchName + '</mark>')
            item.text = item.content.replace(/<[^>]+>/g, '')
            item.text = item.text.replace(/&nbsp;/g, '')
            item.text = item.text.replace(/&ldquo;/g, '"')
            item.text = item.text.replace(/&rdquo;/g, '"')
            item.text = item.text.replace(this.listForm.searchName, '<mark >' + this.listForm.searchName + '</mark>')
          })
        } else {
          this.FAQList = []
          this.tutorialList = []
        }
      })
    },
    toTutorialDetail(e) {
      this.$router.push({
        path: '/tutorial-detail',
        query: {
          content: JSON.stringify(e)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-center {
  padding: 50px 0;
  h6 {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 60px;
    span {
      color: #121e26;
    }
  }
  h1 {
    padding-top: 30px;
    font-weight: 600;
    font-size: 25px;
    color: #121e26;
    line-height: 60px;
  }
  .faq-list {
    h2 {
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      color: #121e26;
    }
    div {
      font-family: Poppins, Poppins-Regular !important;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
    }
  }
}
//移动端样式
.mobile-search-center {
  width: 100%;
  padding: 3.2rem 0.32rem 0.5rem;
  min-height: 100vh;

  h1 {
    font-weight: 500;
    font-size: 0.36rem;
    line-height: 0.54rem;
    color: #10141d;
  }
  .mobile-faq-list {
    font-size: 0.28rem !important;
    h2 {
      font-weight: 500;
      font-size: 0.28rem;
      line-height: 0.42rem;
      color: #10141d;
      padding: 0.1rem 0;
    }
    div {
      font-size: 0.28rem !important;
      line-height: 0.42rem !important;
      color: #8b93a3!important;
    }
  }
}
.search-bar{
  width: 100%;
  position:fixed;
  padding: 1.28rem 0.32rem 0;
  top:0;
  h6 {
    padding: 0.4rem 0;
    font-weight: 400;
    font-size: 0.28rem;
    color: #7b7b7b;
  }
}
</style>
